import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// material-ui components
import withStyles from "material-ui/styles/withStyles";

// @material-ui/icons

// core components
import Header from "components/Header/Header.jsx";
import Footer from "./Components/Footer.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import HeaderLinks from "./Components/HeaderLinks.jsx";
import Parallax from "components/Parallax/Parallax.jsx";

import nodizurcPageStyle from "assets/jss/material-kit-react/views/landingPage.jsx";

// Sections for this page
import ProductSection from "./Sections/ProductSection.jsx";
import TeamSection from "./Sections/TeamSection.jsx";

const logo = require('assets/img/logo-nodizurc.png');

const dashboardRoutes = [];

class Nodizurc extends React.Component {
  render() {
    const { classes, ...rest } = this.props;

    const brand = <img src={logo} alt="nodizurc logo" width="150px" />;

    return (
      <div>
        <Header
          color="transparent"
          routes={dashboardRoutes}
          brand={brand}
          rightLinks={<HeaderLinks />}
          fixed
          changeColorOnScroll={{
            height: 400,
            color: "white"
          }}
          {...rest}
        />
        <Parallax filter image={require("assets/img/landing-bg-nodizurc.jpg")}>
          <div className={classes.container}>
            <GridContainer>
              <GridItem xs={12} sm={12} md={6}>
                <h1 className={classes.title}>Limpeza como nunca antes vista</h1>
                <h4>
                  {brand} é uma marca de produtos de limpeza profissional que atua em vários setores destacando-se a limpeza de paredes como o produto representativo da marca
                </h4>
                <br />
              </GridItem>
            </GridContainer>
          </div>
        </Parallax>
        <div className={classNames(classes.main, classes.mainRaised)}>
          <div className={classes.container}>
            <ProductSection />
            <TeamSection />
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

export default withStyles(nodizurcPageStyle)(Nodizurc);



// WEBPACK FOOTER //
// ./src/views/Nodizurc/Nodizurc.jsx